import { createContext, useContext, useState } from "react";
import ReactDOM from "react-dom";
import "../../styles/alert.scss";
import { RiCheckFill, RiCloseFill, RiInfoI } from "react-icons/ri";

const AlertContext = createContext();

export const useAlert = () => useContext(AlertContext);

export function AlertProvider({ children }) {
    const [alert, setAlert] = useState(null);

    const showAlert = (params) => setAlert({ type: "confirm", ...params });
    const showSuccess = (params) => setAlert({ type: "success", ...params });
    const showError = (params) => setAlert({ type: "error", ...params });

    const close = () => {
        alert?.onClose?.();
        setAlert(null)
    };

    return (
        <AlertContext.Provider value={{ showAlert, showSuccess, showError }}>
            {children}

            {alert && ReactDOM.createPortal(<AlertModal alert={alert} close={close} />, document.body)}
        </AlertContext.Provider>
    );
}

function AlertModal({ alert, close }) {
    const icone = () => {
        switch (alert.icon) {
            case "success":
                return (
                    <div className="icon-success">
                        <RiCheckFill />
                    </div>
                );
            case "error":
                return (
                    <div className="icon-error">
                        <RiCloseFill />
                    </div>
                );
            case "warning":
                return (
                    <div className="icon-info">
                        <RiInfoI />
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="alert-overlay" onClick={close}>
            <div className="alert-box" style={{ ...(alert.style ?? {}) }} onClick={(e) => e.stopPropagation()}>
                {alert.type === "confirm" && (
                    <>
                        <div style={{ padding: 24 }}>
                            <div className="d-flex align-items-center justify-content-between" style={{ paddingBottom: 24 }}>
                                <h2 className="alert-title">{alert.title}</h2>

                                {!alert.notClose && <RiCloseFill size={20} color="#777777" style={{ cursor: "pointer" }} onClick={close} />}
                            </div>

                            <div style={{ paddingTop: 16 }}>
                                {alert.icon ? (
                                    <div className="d-flex justify-content-center" style={{ marginBottom: 24 }}>
                                        {icone()}
                                    </div>
                                ) : null}

                                <p className="alert-subtitle" style={{ ...(alert.textStyle ?? {}) }}>
                                    {alert.text}
                                </p>
                            </div>

                        </div>

                        {(alert.confirmButton || alert.cancelButton) && (
                            <div className="alert-container-botoes" style={{ ...(alert.buttonsContainerStyle ?? {}) }}>
                                {alert.confirmButton && (
                                    <button
                                        className={alert.confirmButtonClass || "btn-confirm"}
                                        onClick={() => {
                                            close();
                                            alert.onConfirm && alert.onConfirm();
                                        }}
                                    >
                                        {alert.confirmText || "Confirmar"}
                                    </button>
                                )}

                                {alert.cancelButton && (
                                    <button
                                        className={alert.cancelButtonClass || "btn-cancel"}
                                        onClick={() => {
                                            close();
                                            alert.onCancel && alert.onCancel();
                                        }}
                                    >
                                        {alert.cancelText || "Voltar"}
                                    </button>
                                )}

                                {alert.extraButton && (
                                    <button
                                        className={alert.extraButtonClass || "btn-line"}
                                        onClick={() => {
                                            close();
                                            alert.onExtra && alert.onExtra();
                                        }}
                                    >
                                        {alert.extraText || "Extra"}
                                    </button>
                                )}
                            </div>
                        )}
                    </>
                )}

                {alert.type === "success" && (
                    <div>
                        <div className="d-flex justify-content-center flex-column align-items-center" style={{ padding: 24, gap: 16 }}>
                            <div className="icon-success">
                                <RiCheckFill />
                            </div>

                            <h2 className="alert-subtitle" style={{ ...(alert.textStyle ?? {}) }}>
                                {alert.title}
                            </h2>
                        </div>

                        <div className="container-buttons">
                            <button className="btn-aux" onClick={close}>
                                {alert.closeText || "Fechar"}
                            </button>
                        </div>
                    </div>
                )}

                {alert.type === "error" && (
                    <div>
                        <div className="d-flex justify-content-center flex-column align-items-center" style={{ padding: 24, gap: 16 }}>
                            <div className="icon-error">
                                <RiCloseFill />
                            </div>

                            <h2 className="alert-subtitle" style={{ ...(alert.textStyle ?? {}) }}>
                                {alert.title}
                            </h2>
                        </div>

                        <div className="container-buttons">
                            <button className="btn-aux" onClick={close}>
                                {alert.closeText || "Fechar"}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

// HOC para uso em class components
export function withAlert(Component) {
    return function WrappedComponent(props) {
        const { showAlert } = useAlert();

        return <Component {...props} showAlert={showAlert} />;
    };
}